import { LogService } from '@hub/shared'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import './advertising.component.scss'

const Advertising = ({ className = '' }) => {
  const logService = useMemo(() => new LogService(), [])
  logService.init('Advertising Component')

  const [t] = useTranslation('globalMain')
  const location = useLocation()

  useEffect(() => {
    try {
      const s = document.createElement('script')
      const div = document.getElementById('div-gpt-ad-1673376698438-0')
      if (div && div.innerHTML === '') {
        s.innerHTML = `
        console.log('trigger 1 googletag');
        googletag.cmd.push(function() { googletag.display('div-gpt-ad-1673376698438-0'); });
      `
        div.appendChild(s)
      }

      const s2 = document.createElement('script')
      const div2 = document.getElementById('div-gpt-ad-1673376559032-0')
      if (div2 && div2.innerHTML === '') {
        s2.innerHTML = `
        console.log('trigger 2 googletag');
        googletag.cmd.push(function() { googletag.display('div-gpt-ad-1673376559032-0'); });
      `
        div2.appendChild(s2)
      }
    } catch (error: any) {
      logService.error({ message: error.message, error })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section className={`publicity ${className} ${!['/campaigns', '/home'].includes(location.pathname) ? 'display-none' : ''}`}>
      <div className="display-flex align-items-center mb-3">
        <hr />
        <p className="px-3" style={{ fontSize: '0.9rem', color: 'var(--gray)' }}>
          {t('advertising')}
        </p>
        <hr />
      </div>
      <div className="publi-banners-wrapper">
        <div className="publi-banners">
          <div
            id="div-gpt-ad-1673376698438-0"
            className="influence-club-banner-image ad-container"
            style={{
              minWidth: '300px',
              minHeight: '250px',
            }}
          />
          <div
            id="div-gpt-ad-1673376559032-0"
            className="influence-club-banner-image ad-container"
            style={{
              minWidth: '300px',
              minHeight: '250px',
            }}
          />
        </div>
      </div>
    </section>
  )
}

export default Advertising
